<template>
    <b-form-select v-model="provinceProduct.tariffa_codice"
                   :options="productsOpt"
                   size="sm"
                   @change="change"
    />
</template>
<script>
import store from "./store";

export default {
    name: 'select-product',
    props: {
        provinceProduct: {},
        province: {
            type: String,
            required: true,
        },
    },
    computed: {
        productsOpt() {
            let products = store.products

            //filter by parent profile
            if (store.parentProfile) {
                const parentProvince = store.parentProfile.province_abilitate[this.province] ?? []
                const parentProducts = parentProvince.map(i => i.tariffa_codice)
                products = products.filter(i => parentProducts.includes(i.value))
            }
            return products
        }
    },
    methods: {
        change() {
            this.provinceProduct.warranty_codice = null
        }
    }
}
</script>
